import { c as _c } from "react/compiler-runtime";
import { useSetDefaultEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-set-default-email-options';
import { DashboardMailEditorProps, ExtendedState } from 'shared/components/dashboard-mail-editor/types/common';
import { useSetDefaultSenderEmail } from 'shared/components/sender-email-select/hooks/use-set-default-sender-email';
export const useSetDefaultEmail = (data, onChange, options) => {
  const $ = _c(3);
  useSetDefaultEmailOptions(data, onChange, options);
  let t0;
  if ($[0] !== data || $[1] !== onChange) {
    t0 = value => data && onChange({
      ...data,
      fromEmail: value
    });
    $[0] = data;
    $[1] = onChange;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useSetDefaultSenderEmail(data?.fromEmail, t0);
};